import { SuccessIcon } from "../../assets/svg";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { Fragment } from "react/jsx-runtime";
import { hideSuccesModal } from "../../store/add-warrnty-item/actions";
import { RootState } from "../../store/root-reducer";
import { navigateTo } from "../../helper";
import RouteNames from "../../routes/type";
import { fetchClaimInfo } from "../../store/claim/actions";

function SubmitWarrntyItems() {
  const dispatch = useDispatch();
  const show = useSelector(
    (state: RootState) => state.warrntyItem.showSucessModal
  );

  const claimId = useSelector((state: RootState) => state.warrntyItem.claimId);
  const warrantyId = useSelector(
    (state: RootState) => state.warrntyItem.warrantyId
  );
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => dispatch(hideSuccesModal())}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="space-y-3 my-3">
                  <SuccessIcon size={98} className="mx-auto" />
                  <Dialog.Title
                    as="h3"
                    className="text-lg  text-center font-medium leading-6 text-gray-900"
                  >
                    Plan item added successfully
                  </Dialog.Title>
                  <p className="text-sm text-center text-gray-500">
                    Thank you for submitting your Plan Item.
                  </p>
                </div>
                <div className="mt-4">
                  <button
                    type="button"
                    className="w-full justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={() => {
                      dispatch(hideSuccesModal());
                      dispatch(
                        fetchClaimInfo({
                          claimId,
                          warranty_id: warrantyId,
                        })
                      );
                      navigateTo(
                        `${RouteNames.CREATE_CLAIM}?step=2&claimId=${claimId}&warranty_id=${warrantyId}`
                      );
                    }}
                  >
                    Back to Claim
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default SubmitWarrntyItems;
